import React from "react";
import Tabla from "../../../globales/componentes/tabla/tabla";
import type { ITablaGestionArchivosVistaProps } from "../interfaces";
import { ActionIcon, Button, Group, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconFilter, IconFilterFilled, IconRefresh } from "@tabler/icons-react";
import FiltroGestionArchivosVista from "./filtroGestionArchivosVista";

const TablaGestionArchivosVista: React.FC<ITablaGestionArchivosVistaProps> = ({ 
  tabla, 
  habilitarFiltros,
  manejarHabilitarFiltros,
  seleccionadas,
  descargarSeleccionados,
  consultarVisitasCliente,
  entidadFiltro,
  manejarCambioValorFiltro,
  limpiarFiltro,
  clientes,
  Proyectos,
  tiposTarea
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowX: 'hidden' }}>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Gestión Archivos</Text>
        <Group>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarVisitasCliente(entidadFiltro)}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
          </Group>

          {seleccionadas.length > 0 && (
            <>
              <Button
                color="primary"
                variant="light"
                size='xs'
                leftSection={<IconCheck color="var(--mantine-color-primary-0)" size={12} />}
                radius="lg"
                onClick={descargarSeleccionados}
              >
                <Text fw={500} size="xs">
                  Descargar Seleccionados ({seleccionadas.length})
                </Text>
              </Button>
            </>
          )}
        </Group>
      </Group>

      {habilitarFiltros && (
        <FiltroGestionArchivosVista  
          entidadFiltro={entidadFiltro}
          manejarCambioValorFiltro={manejarCambioValorFiltro}
          limpiarFiltro={limpiarFiltro}
          consultarVisitasCliente={consultarVisitasCliente}
          clientes={clientes}
          Proyectos={Proyectos}
          tiposTarea={tiposTarea}

        />
      )}

      <Tabla maxHeight={habilitarFiltros ? 300 : 350} tabla={tabla} />
    </div>
  );
};

export default React.memo(TablaGestionArchivosVista);
